import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import CommunityApi from "../../../api/community.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";

function MoveModal({
  setModalOpen,
  negative,
  currentCategory,
  currentCategoryId,
  id,
  onMoved,
}) {
  const [selectBoxOpen, setSelectBoxOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState();

  const [categoryList, setCategoryList] = useState([]);

  const getCategory = async () => {
    try {
      let responseData = (await CommunityApi.getCategory({ size: 1000 })).data
        .data.content;

      setCategoryList(responseData.filter((item) => item.id !== 1));
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  const changeCategory = async () => {
    try {
      if (
        !selectedCategoryId ||
        Number(selectedCategoryId) === Number(currentCategoryId)
      ) {
        return toast("이동할 카테고리를 선택해주세요.");
      }

      const data = {
        communityCategoryId: selectedCategoryId,
      };

      await CommunityApi.changeCategory(id, data);

      toast("카테고리가 변경되었습니다.");
      setModalOpen(false);
      onMoved?.();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <ModalWrapper>
      <ModalBox>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ModalTitle>게시글 이동</ModalTitle>
          <ModalText>게시글을 이동할 경우 댓글이 함께 이동합니다.</ModalText>
        </div>
        <div style={{ width: "100%" }}>
          <PretendardText
            style={{
              color: "#000000",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",
              marginBottom: "10px",
            }}
          >
            게시판
          </PretendardText>
          <div style={{ position: "relative", width: "100%" }}>
            <SelectBoxWrapper
              onClick={() => {
                setSelectBoxOpen(!selectBoxOpen);
              }}
              style={{ cursor: "pointer" }}
            >
              <PretendardText
                style={{
                  color: "#808991",
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "21.25px",
                }}
              >
                {selectedCategory || currentCategory}
              </PretendardText>
              <img src="/assets/admin/icons/ico_select_arrow_down.svg" alt="" />
            </SelectBoxWrapper>
            {selectBoxOpen ? (
              <SubMenuWrapper>
                {categoryList.map((item, index) => {
                  return (
                    <SubMenuTextWrapper
                      key={index}
                      onClick={() => {
                        setSelectBoxOpen(false);
                        setSelectedCategory(item.title);
                        setSelectedCategoryId(item.id);
                      }}
                    >
                      <PretendardText
                        style={{
                          color: "#262C31",
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      {currentCategory === item.title ? <img src="/assets/admin/icons/ico_select_checked.svg" alt="" /> : null}
                    </SubMenuTextWrapper>
                  );
                })}
              </SubMenuWrapper>
            ) : null}
          </div>
        </div>
        <ModalBtnWrapper>
          <ModalBtn onClick={() => setModalOpen(false)}>취소</ModalBtn>
          <CancelBtn onClick={changeCategory} $negative={negative}>
            확인
          </CancelBtn>
        </ModalBtnWrapper>
      </ModalBox>
    </ModalWrapper>
  );
}

export default MoveModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 394px;
  min-height: 173px;
  height: auto;
  padding: 40px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);

  /* 스크롤바 스타일 */
  &::-webkit-scrollbar {
    width: 17px; /* 스크롤바 너비 */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* 스크롤바 트랙 배경색 */
    border-radius: 10px; /* 스크롤바 트랙 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바 색상 */
    border: 7px solid #fff;
    border-radius: 10px; /* 스크롤바 둥근 모서리 */
  }
`;

const ModalTitle = styled(PretendardText).attrs((props) => {})`
  font-size: 22px;
  font-weight: 700;
  line-height: 33px;
  color: #262c31;
  text-align: center;
`;

const ModalText = styled(PretendardText).attrs((props) => {})`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #808991;
  text-align: center;
  margin-top: 6px;
`;

const ModalBtnWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

const CancelBtn = styled.button.attrs((props) => {})`
  width: 76px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: ${(props) => (props.$negative ? "#F24147" : "#279eff")};
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  border-radius: 100px;
`;

const ModalBtn = styled.button.attrs((props) => {})`
  width: 76px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #636c73;
  background: #f2f4f5;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  border-radius: 100px;
`;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  max-height: 200px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;

  &::-webkit-scrollbar {
    width: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바의 색상 */
    border-radius: 9px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;
